<template>
  <div>
    <v-dialog
      v-model="addEditDialog"
      persistent
      max-width="500px"
      transition="slide-y-transition"
    >
      <v-card class="dialog-card-border">
        <v-card-title class="text-h6 font-weight-light">
          {{ editMode ? $t('Update Receipt') : $t('Add New Receipt') }}
        </v-card-title>

        <validation-observer
          ref="theForm"
          v-slot="{ handleSubmit, reset }"
        >
          <form
            autocomplete="off"
            @submit.prevent="handleSubmit(submit)"
            @reset.prevent="reset"
          >
            <v-card-text>
              <v-row no-gutters>
                <v-col
                  class="px-2 text-h6 mb-6 font-weight-bold warning--text"
                  cols="12"
                >
                  {{ $t('Customer Balance') }}: {{ $_format_number(formData.customer_balance) }}
                </v-col>

                <v-col
                  v-if="formData.last_receipt && formData.last_receipt.diff_in_days"
                  class="px-2 mb-6 text-subtitle-1"
                  cols="12"
                >
                  {{ $t('Last Receipt Date') }}: {{ $_format_date(formData.last_receipt.last_receipt_date) }}
                  <span class="ps-4">
                    {{ formData.last_receipt.diff_in_days }} {{ $t('Days ago') }}
                  </span>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                >
                  <app-branch-select
                    v-model="formData.branch_id"
                    @branch-selected="customersList = $event.customers"
                  />
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Customer')"
                    rules="required"
                  >
                    <v-autocomplete
                      v-model="formData.customer_id"
                      :label="`* ${$t('Customer')}`"
                      :items="customersList"
                      :item-text="item => `${item.name} | ${item.phone1}`"
                      :item-value="item => item.id"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                      @input="customerSelected(formData.customer_id)"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Amount')"
                    rules="required"
                  >
                    <v-currency-field
                      v-model="formData.amount"
                      :label="`* ${$t('Amount')}`"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Note')"
                  >
                    <app-date-picker
                      v-model="formData.action_date"
                      :label="$t('Date')"
                      :error-messages="errors"
                      no-title
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Note')"
                  >
                    <v-textarea
                      v-model="formData.note"
                      :label="$t('Note')"
                      outlined
                      dense
                      rows="3"
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions class="py-3">
              <app-form-tip />

              <v-spacer />

              <v-btn
                depressed
                outlined
                small
                @click="closeDialog()"
              >
                {{ $t('Cancel') }}
              </v-btn>

              <app-submit-button :edit-mode="editMode" />
            </v-card-actions>
          </form>
        </validation-observer>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'

export default {
  props: {
    addEditDialog: { type: Boolean, default: false },
    formData: { type: Object, default: () => { } },
    editMode: { type: Boolean, default: false },
  },

  data() {
    return {
      dateMenu: false,
      customersList: []
    }
  },

  watch: {
    addEditDialog(newVal) {
      if (newVal && this.editMode) {
        this.customerSelected(this.formData.customer_id)
      }
    }
  },

  methods: {
    async customerSelected(customerId) {
      await axios.get(`customer/${customerId}/get-balance/`).then(res => {
        Vue.set(this.formData, 'customer_balance', res.data.balance)
      })

      if (!this.editMode) {
        axios.get(`customer/${customerId}/get-current-receipt-amount/`).then(res => {
          if (this.formData.customer_balance < res.data) {
            Vue.set(this.formData, 'amount', this.formData.customer_balance)
          } else {
            Vue.set(this.formData, 'amount', res.data)
          }
        })

        axios.get(`customer/${customerId}/get-last-receipt/`).then(res => {
          Vue.set(this.formData, 'last_receipt', res.data)
        })
      }
    },

    closeDialog() {
      this.$refs.theForm.reset()
      this.$emit('close')
    },

    submit() {
      if (this.editMode) {
        axios.put(`receipt/${this.formData.id}/`, this.formData).then(() => {
          this.$_notify('Updated successfully')
          this.closeDialog()
          this.$emit('update-table-data')
        })
      } else {
        axios.post('receipt/', this.formData).then(res => {
          this.$_notify('Added successfully')
          this.closeDialog()
          this.$emit('reset-table-data', res.data)
        })
      }
    }
  },
}
</script>
